import React from 'react';
import IframePage from "../iframe-page/iframe-page";
import config from "../../config";

const LocalizationPage: React.FC<{scope: string}> = ({scope}) => {
    return (
        <IframePage url={`${config.apiUrl}/dashboard/settings/${scope}/localization`} />
    );
}

export default LocalizationPage;